export enum JobRole {
  KILeader = 'KI Leader',
  TeamManager = 'TM',
  ChiefOfResearch = 'CoR',
  GeneralUser = 'General User'
}
